var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-html2pdf"},[_c('div',{ref:"pdfContent",staticClass:"pdf-export-container",style:(_vm.contentStyle)},[_vm._t("pdf-content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }